(ns frontend.ui.component.lp-portal.report.component.overview-figures.style
  (:require
   [frontend.ui.component.grid.style :as grid-style]
   [frontend.ui.component.text.style :as text-style]
   [frontend.ui.style.theme.core :as theme]
   [garden.units :refer [px]]))

(defn responsive-cols
  [figure-count]
  (case figure-count
    12 1
    8 3
    7 2
    6 2
    5 3
    4 3
    3 4
    2 6
    1 12))

(defn figure-column
  "`val-count`: the number of values to display. Currently only supports 3 or 4 values (default: 4)"
  ([]
   (figure-column 4))
  ([val-count]
   (with-meta
     {:margin-bottom   "16px"
      :display         "flex"
      :justify-content "center"}
     {:extend [grid-style/column {:small 6 :large (responsive-cols val-count)}]})))

(defn figure-container
  [no-border?]
  ^{:media {{:screen :only :max-width (px 991)}
            {:margin-bottom "12px"}}}
  (merge {:text-align       :center
          :display          "inline-flex"
          :padding-top      "16px"
          :flex-direction   :column}
         (when-not no-border? 
           {:border-top-width "2px"
            :border-top-style "solid"
            :border-top-color (theme/color [:general-border :border])})))

(defn figure
  []
  ^{:media {{:screen :only :max-width (px 991)}
            {:font-size "36px"}}}
  {:font-size      (if (= (theme/get-theme) :theme.lp-portal/lifeline) "42px" "72px")
   :font-family    "Mulish, sans-serif"
   :letter-spacing "-0.5px"
   :color          (theme/color [:figure :primary :color])
   :font-weight    "bold"
   :line-height    :1})

(defn figure-label
  []
  ^{:extend [text-style/text {}]}
  {:font-weight "600"
   :font-size   "16px"
   :color       (theme/color [:figure :primary :color])})

(defn figure-comment
  []
  ^{:extend [text-style/text {}]}
  {:font-weight      "500"
   :font-size        "14px"
   :color            (theme/color [:figure :primary :color])
   :background-color (theme/color [:figure :comment :bg])
   :border-radius    "6px"
   :padding          "3px"})
